import { all, put, call, takeEvery } from "redux-saga/effects";
import axios from "axios";
import * as actions from "./actions";

function* checkOauthLogin(action) {
  const { payload } = action.payload;
  try {
    const url = `${process.env.REACT_APP_QC_OAUTH_SERVICE_GO}/qcauthorize`;
    console.log("[checkOauthLogin] POST", url, { type: payload.type });

    const res = yield call(axios.post, url, payload);
    console.log("[checkOauthLogin] Go response", res.data);

    if (res.data?.data?.status === "error") {
      yield put(actions.checkOauthLogin.failure("error", res.data.data.msg || "Login failed"));
      return;
    }

    let {
      data: {
        data: {
          token,
          permissions,
          vehicle_list,
          location_list,
          vehicle_group_list,
          divisions,
          departments,
          sections,
        },
      },
    } = res;

    let base64Url = token.split(".")[1];
    let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    let deToken = JSON.parse(window.atob(base64));
    console.log("[checkOauthLogin] JWT decoded", deToken);
    console.log("[checkOauthLogin] permissions", permissions);

    const callbackUrl = localStorage.getItem("callbackUrl");
    actions.removeCredentials();
    yield call(() =>
      actions.storeCredentials(
        token,
        deToken,
        permissions,
        vehicle_list,
        location_list,
        vehicle_group_list,
        divisions,
        departments,
        sections,
      )
    );
    yield put(
      actions.checkOauthLogin.success(
        token,
        deToken,
        permissions,
        vehicle_list,
        location_list,
        vehicle_group_list,
        divisions,
        departments,
        sections,
      )
    );
    console.log("[checkOauthLogin] login success, redirecting to", callbackUrl || "/");
    if (callbackUrl) {
      window.location.href = callbackUrl;
    } else {
      window.location.href = "/";
    }
  } catch (err) {
    console.error("[checkOauthLogin] error", err);
    if (err.message.indexOf("400") !== -1)
      yield put(actions.checkOauthLogin.failure("error", "Invalid username or password!"));
    else if (err.message.indexOf("401") !== -1)
      yield put(actions.checkOauthLogin.failure("error", "Account expired!"));
    else if (err.message.indexOf("503") !== -1)
      yield put(actions.checkOauthLogin.failure("error", "Service Unavailable!"));
    else if (err.message.indexOf("502") !== -1)
      yield put(actions.checkOauthLogin.failure("error", "Bad Gateway!"));
    else if (err.message.indexOf("504") !== -1)
      yield put(actions.checkOauthLogin.failure("error", "Gateway Timeout!"));
    else
      yield put(actions.checkOauthLogin.failure("error", "Something went wrong!"));
  }
}

export default function* watchOauthLogin() {
  yield all([takeEvery(actions.CHECK_OAUTH_LOGIN.REQUEST, checkOauthLogin)]);
}
